import { render, staticRenderFns } from "./voiceCall.vue?vue&type=template&id=a44956fe&scoped=true&"
import script from "./voiceCall.vue?vue&type=script&lang=js&"
export * from "./voiceCall.vue?vue&type=script&lang=js&"
import style0 from "./voiceCall.vue?vue&type=style&index=0&id=a44956fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44956fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/BgUizHzZB/0/snt/info/info-customer/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a44956fe')) {
      api.createRecord('a44956fe', component.options)
    } else {
      api.reload('a44956fe', component.options)
    }
    module.hot.accept("./voiceCall.vue?vue&type=template&id=a44956fe&scoped=true&", function () {
      api.rerender('a44956fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Robot/voiceCall.vue"
export default component.exports